/** Look-up › Quality › DoV Calculator (a packaging utility, user 2026-10-28). */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { DovCalculatorPage } from "@/features/packaging/components/utilities-page";

export const Route = createFileRoute("/_app/quality/dov-calculator/")({
  beforeLoad: () => {
    if (!useAuth.getState().can("qc.dov_calculator"))
      throw redirect({ to: "/" });
  },
  component: DovCalculatorPage,
});
